import React from "react";
import PropTypes from "prop-types";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { updateDocumentScoringKnockoutCriteria } from "../actionCreators";
import { rulesEngine } from "utils/rules-engine";
import { falseWhen, valueChanged } from "utils/fn-combinators";
import DocumentScoringKnockoutCriteriaListComponent from "./DocumentScoringKnockoutCriteriaListComponent";

class DocumentScoringKnockoutCriteriaListContainer extends React.PureComponent {
  state = {
    knockoutCriteriaList: this.props.knockoutCriteriaList,
    saving: false
  };

  businessRules = {
    autoApproval: falseWhen(valueChanged(document => document.resultOk))
  };

  componentDidUpdate(prevProps) {
    if (prevProps.knockoutCriteriaList !== this.props.knockoutCriteriaList) {
      this.setState({
        knockoutCriteriaList: this.props.knockoutCriteriaList,
        saving: false
      });
    }
  }

  handlePropertyChange = (index, prop, value) => {
    this.setState(prevState => {
      const { document } = rulesEngine.update(prevState.knockoutCriteriaList[index], this.businessRules, {
        [prop]: value
      });
      const newKnockoutCriteriaList = Object.assign([...prevState.knockoutCriteriaList], { [index]: document });
      return {
        knockoutCriteriaList: newKnockoutCriteriaList
      };
    });
  };

  isDirty = () => this.state.knockoutCriteriaList !== this.props.knockoutCriteriaList;

  handleSave = async () => {
    if (!this.isDirty()) return;

    const { documentId, siteId, documentScoringGridId, actions, fromPartner, partnerId } = this.props;
    const { knockoutCriteriaList } = this.state;

    this.setState({ saving: true });
    try {
      await actions.updateDocumentScoringKnockoutCriteria(
        documentId,
        siteId,
        documentScoringGridId,
        knockoutCriteriaList,
        fromPartner,
        partnerId
      );
    } catch (error) {
      // continue regardless of error
    }
    this.setState({ saving: false });
  };

  render() {
    const { knockoutCriteriaList, saving } = this.state;
    const { disabled, isHistory, knockoutCriteriaInProgress, evaluateKnockout, fromPartner } = this.props;

    return (
      <DocumentScoringKnockoutCriteriaListComponent
        knockoutCriteriaList={knockoutCriteriaList}
        onPropertyChange={this.handlePropertyChange}
        onSave={this.handleSave}
        saving={saving}
        knockoutCriteriaInProgress={knockoutCriteriaInProgress}
        evaluateKnockout={evaluateKnockout}
        disabled={disabled}
        isHistory={isHistory}
        isDirty={this.isDirty()}
        fromPartner={fromPartner}
      />
    );
  }
}

DocumentScoringKnockoutCriteriaListContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  documentScoringGridId: PropTypes.number,
  knockoutCriteriaList: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  isHistory: PropTypes.bool,
  knockoutCriteriaInProgress: PropTypes.bool,
  evaluateKnockout: PropTypes.func,
  fromPartner: PropTypes.bool,
  partnerId: PropTypes.number
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ updateDocumentScoringKnockoutCriteria }, dispatch)
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(DocumentScoringKnockoutCriteriaListContainer);
